import { useState, useEffect } from "react";
// import { MODULOS_ADMINISTRACION_USUARIO } from "../../utils/modulos-administracion-usuario";
import Modulo from "../../components/modulo";
import { useModulosAdministracionUsuario } from "../../utils/modulos-administracion-usuario";
// import {
//   INT_ID_MODULO_USUARIOS,
//   INT_ID_SEGUNDO_NIVEL_USUARIOS,
//   INT_TIPO_USUARIO_ADMINISTRADOR_WEB,
// } from "../../utils/const-int";
// import { obtenerPermisosPorNivelUsuarioWeb } from "../../api/permisos/permisos";
// import { TRUE } from "../../utils/const-bool";

const idTipoUsuario = parseInt(localStorage.getItem("tipoUsuarioChecklist"));

export default function AdministracionUsuario() {

  const [cargandoPage, setCargandoPage] = useState(false);
  const MODULOS_ADMINISTRACION_USUARIO = useModulosAdministracionUsuario();
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      /*let objPermiso = {};
      objPermiso.idMenuPrimerNivel = INT_ID_MODULO_USUARIOS;
      objPermiso.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_USUARIOS;
      objPermiso.idMenuTercerNivel = 0;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(objPermiso);
      console.log('obtenerPermisos');
      console.log(obtenerPermisos);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setTieneAccesoAlModulo(true);
      }
      if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        if (permiso.accesoAlModulo === TRUE) {
          setTieneAccesoAlModulo(true);
        }
      }*/
      setTieneAccesoAlModulo(true);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const render = () => {
    try {
      if (cargandoPage === true) {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: 30,
            }}
          >
            <div className="loader"></div>
            <div
              style={{ marginTop: 10, }}
            >
              <p>Cargando...</p>
            </div>
          </div>
        );
      }
      if (tieneAccesoAlModulo === false) {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: 30,
            }}
          >
            <div
              style={{ marginTop: 10, }}
            >
              <p>Sin Acceso Al Modulo...</p>
            </div>
          </div>
        );
      }
      return (
        <div>
          <div className="flex flex-wrap">
            {MODULOS_ADMINISTRACION_USUARIO.map((data) => Modulo(data))}
          </div>
        </div>
      );
    } catch (err) {
      console.log("AdministracionUsuario render");
      console.log(err);
      return (
        <div className=" w-1/2 m-auto px-[2rem] ">
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  };

  return render();
}
